import React from 'react';
import { Masonry } from '@forgeglobal/design-framework';
import useMasonryDynamicColumns from '@tcs/common/hooks/useMasonryDynamicColumns';
import PersonalInfoCard from '@tcs/client-portal-common/components/templates/DetailCards/PersonalInfoCard';
import AddressCard from '@tcs/client-portal-common/components/templates/DetailCards/AddressCard';
import ContactInfoCard from '@tcs/client-portal-common/components/templates/DetailCards/ContactInfoCard';
import { AccountProfile } from '@tcs/client-portal-api/src/types/AccountProfile';

interface PersonalInfoProps {
  profile: AccountProfile;
}

const PersonalInfo = ({ profile }: PersonalInfoProps) => {
  const dynamicColumns = useMasonryDynamicColumns('lg', 2);

  if (!profile) {
    return null;
  }

  const { personalInfo, contactInfo, address } = profile;

  return (
    <Masonry numCols={dynamicColumns}>
      <PersonalInfoCard personalInfo={personalInfo} />
      <AddressCard address={address} />
      <ContactInfoCard contactInfo={contactInfo} />
    </Masonry>
  );
};

export default PersonalInfo;
